const scroll_functions = () => {

    // navbar
    let navbar = document.querySelector("#navbar"),
        navbar_height = navbar.offsetHeight + 50,
        scrollpos = window.scrollY

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY

        if (scrollpos >= navbar_height) {
            navbar.classList.add("navbar-scrolled")
        } else {
            navbar.classList.remove("navbar-scrolled")
        }

        // bouton toTop
        document.getElementById("toTop").className = (scrollpos > 200) ? "cVisible" : "cInvisible"
    })

    // ancres html avec scroll
    if (navigator.userAgent.indexOf('Edge') < 0) {
        let anchors = document.querySelectorAll('a[href*="#"]')

        anchors.forEach(function(anchor) {
            anchor.addEventListener('click', function(e) {
                if (anchor.classList.contains('no-scroll') || anchor.parentElement.classList.contains('no-scroll')) {
                    e.preventDefault()
                    return false
                } else {
                    let urlSplit = anchor.getAttribute("href").split('#'),
                        the_id = '#' + urlSplit[urlSplit.length - 1]

                    if (the_id === '#' || (urlSplit[0] !== document.location.href.split('#')[0] && urlSplit[0] !== '')) {
                        return false
                    } else if (the_id === '#top') {
                        e.preventDefault()
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        })
                        return false
                    } else {
                        e.preventDefault()
                        let target = document.querySelector(the_id)

                        window.scrollTo({
                            top: target.offsetTop - 120,
                            left: 0,
                            behavior: 'smooth'
                        })
                        return false
                    }
                }
            })
        })
    }
}

const anchor_scroll_at_load = () => {

    window.addEventListener('load', () => {
        // aller à l'ancre au chargement de page
        let id = document.location.hash

        if (id !== '') {
            if (id.match('#')) {
                let target = document.querySelector(id)

                if (target !== null) {
                    window.scrollTo({
                        top: target.offsetTop - 120,
                        left: 0
                    })
                }
                
                return false
            }
        }
    })
}

export { scroll_functions, anchor_scroll_at_load }
